module.exports = __webpack_public_path__ + "img/section3_banner3.d1b5e25a.jpg";